import { useEffect, useRef, useState } from 'react'
import './savings.css'

const PAPER_PRICE = 15
const VLINK_PRICE = 800
const PAYBACK_COUNT = Math.ceil(VLINK_PRICE / PAPER_PRICE)
const rubles = (value: number) => `${value.toLocaleString('ru-RU')} ₽`
const cardsLabel = (count: number) => {
    const form = new Intl.PluralRules('ru-RU').select(count)
    return form === 'one' ? 'визитка' : form === 'few' ? 'визитки' : 'визиток'
}

export const CatalogSavings = ({paused = false}: {paused?: boolean}) => {
    const root = useRef<HTMLElement>(null)
    const [count, setCount] = useState(1)
    const [running, setRunning] = useState(true)
    const [visible, setVisible] = useState(false)
    const [reduced, setReduced] = useState(false)

    useEffect(() => {
        const preference = window.matchMedia('(prefers-reduced-motion: reduce)')
        const update = () => setReduced(preference.matches)
        update()
        preference.addEventListener('change', update)
        const observer = new IntersectionObserver(([entry]) => setVisible(entry.isIntersecting), {threshold: 0.2})
        if (root.current) observer.observe(root.current)
        return () => { observer.disconnect(); preference.removeEventListener('change', update) }
    }, [])

    useEffect(() => {
        if (!running || !visible || paused || reduced || count >= 100) return
        const timer = window.setTimeout(() => setCount(value => Math.min(100, value + 1)), 180)
        return () => window.clearTimeout(timer)
    }, [count, running, visible, paused, reduced])

    const paperCost = count * PAPER_PRICE
    const savings = paperCost - VLINK_PRICE
    const changeCount = (value: number) => { setRunning(false); setCount(value) }
    const playing = running && count < 100 && !reduced

    return (
        <section className="catalog-savings" ref={root} aria-labelledby="catalog-savings-title">
            <div className="catalog-savings-heading">
                <div>
                    {/* <span className="catalog-kicker">ОДНА КАРТА. МНОГО ЗНАКОМСТВ.</span> */}
                    {/* <h2 id="catalog-savings-title">Знакомства растут.<br /><em>Расходы — нет.</em></h2> */}
                    <h2 id="catalog-savings-title">Расчет выгоды</h2>
                </div>
                {/* <p>Бумажную визитку вы отдаёте каждый раз. Vlink остаётся у вас — клиент открывает её по QR или NFC.</p> */}
            </div>
            <div className="catalog-savings-comparison">
                <div className="catalog-savings-side">
                    <span className="catalog-savings-label">БУМАЖНЫЕ ВИЗИТКИ</span>
                    <div className="catalog-savings-paper" aria-hidden="true"><span /><span /></div>
                    <p className="catalog-savings-quantity">{count} {cardsLabel(count)} × ≈{PAPER_PRICE} ₽</p>
                    <strong className="catalog-savings-price">≈{rubles(paperCost)}</strong>
                    <p className="catalog-savings-caption">Расходы с каждой новой визиткой</p>
                </div>
                <div className="catalog-savings-side catalog-savings-vlink">
                    <span className="catalog-savings-label">ЭЛЕКТРОННАЯ ВИЗИТКА VLINK</span>
                    <div className="catalog-savings-card" aria-hidden="true"><span>Vlink</span></div>
                    <p className="catalog-savings-quantity">1 пластиковая карта</p>
                    <strong className="catalog-savings-price">{rubles(VLINK_PRICE)}</strong>
                    <p className="catalog-savings-caption">Один раз. Каждый переход — бесплатно.</p>
                </div>
            </div>
            <div className="catalog-savings-controls">
                {/* <div className="catalog-savings-control-head">
                    <label htmlFor="catalog-savings-count">Сколько визиток вы бы раздали? <strong>{count}</strong></label>
                    {!reduced && <button type="button" onClick={() => {
                        if (playing) setRunning(false)
                        else { if (count >= 100) setCount(1); setRunning(true) }
                    }}>{playing ? 'Пауза' : count >= 100 ? 'Сначала ↻' : 'Продолжить'}</button>}
                </div> */}
                <input id="catalog-savings-count" type="range" min="1" max="500" step="1" value={count} onPointerDown={() => setRunning(false)} onKeyDown={() => setRunning(false)} onChange={event => changeCount(Number(event.target.value))} aria-valuetext={`${count} ${cardsLabel(count)}, примерно ${paperCost} рублей`} />
                <div className="catalog-savings-scale"><span>1 визитка</span><button type="button" onClick={() => changeCount(PAYBACK_COUNT)}>Окупаемость: {PAYBACK_COUNT} шт. ↗</button><span>500 визиток</span></div>
            </div>
            <div className={`catalog-savings-result${savings >= 0 ? ' is-paid-off' : ''}`} aria-live={playing ? 'off' : 'polite'}>
                <span>{savings >= 0 ? 'Вы уже экономите' : `Vlink окупается на ${PAYBACK_COUNT}-й бумажной визитке`}</span>
                <strong>{savings >= 0 ? `≈${rubles(savings)}` : `${PAYBACK_COUNT} × ${PAPER_PRICE} ₽ = ${rubles(PAYBACK_COUNT * PAPER_PRICE)}`}</strong>
            </div>
            {/* <p className="catalog-savings-note">Расчёт при цене бумажной визитки ≈15 ₽ и карты Vlink 800 ₽. Сравниваем стоимость передачи контактов: вместо каждой бумажной визитки — бесплатный переход по электронной.</p> */}
        </section>
    )
}
